module.exports = __webpack_public_path__ + "static/img/s163.eeac4548.png";